
const env = 'production'; //(process.env.NODE_ENV || 'development');
const baseURL = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api');
const authURL = (process.env.REACT_APP_AUTH_BASE_URL || 'http://localhost:3001/');
const socketURL = (process.env.REACT_APP_SOCKET_BASE_URL || 'http://localhost:3001/');
const reLoginURL = (process.env.REACT_APP_RE_LOGIN_URL || 'http://localhost:3000/');
export const googleAnalyticsID = (process.env.REACT_APP_GOOGLE_ANALYTICS_ID || '');

export const isProductionEnvironment = ():boolean => {
  return env == 'production';
}

export const getAPIBaseURL = ():string => {
    return baseURL;
}

export const getAuthBaseURL = ():string => {
    return authURL;
}

export const getSocketURL = ():string => {
    return socketURL;
}

export const getReLoginURL = ():string => {
    return reLoginURL;
}

const canadaENV = 'CA';
const usaENV = 'USA';

// Set the nation environment here
const country = (process.env.REACT_APP_PGB_COUNTRY || usaENV);

export const isCanada = ():boolean => {
    return country == canadaENV;
}

export const isUSA = ():boolean => {
    return country == usaENV;
}

export const getCountryCode = ():string => {
    return country;
}

const seedBrandDynaGro = 'dyna-gro';
const seedBrand = (process.env.REACT_APP_SEED_BRAND || seedBrandDynaGro);

export const getSeedBrand = ():string => {
    return seedBrand;
}

export const isDynaGro = ():boolean => {
    return seedBrand == seedBrandDynaGro;
}



// WEBPACK FOOTER //
// ./src/config.ts